export const figure49 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    marginLeft: 200,
    spacingBottom: 45,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    height: '800px',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    
    }
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false,
  }, 
  exporting: {
    enabled: false
  },
  colors: ['#5b9bd5', '#ed7d31'],
  xAxis: {
      categories: [
		   "Europe septentrionale",
		   "Asie du Sud",
		   "Micronésie",
		   "Amérique du Sud",
		   "Asie du Sud-Est",
		   "Asie de l’Est",
		   "Afrique du Nord",
		   "Afrique de l’Est",
		   "Europe orientale",
		   "Asie centrale",
		   "Afrique australe",
		   "Afrique de l’Ouest",
		   "Europe occidentale",
		   "Caraïbes",
		   "Europe méridionale",
		   "Mélanésie",
		   "Afrique moyenne",
		   "Polynésie",
		   "Amérique centrale",
		   "Amérique du Nord",
		   "Asie de l’Ouest",
  ],
      crosshair: true
  },
  yAxis: {
      max: 120.00,
      min: 0,
      tickInterval: 20,
      title: {
          text: null
      }
  },
  tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
      
  },
  plotOptions: {
      column: {
          pointPadding: 0.2,
          borderWidth: 0,
      }
  },
  series: [
  {
      name: '',
      data: [
          91.65,
          94.46,
          96.73,
          98.79,
          99.8,
          99.65,
          100.38,
          101.22,
          101.92,
          102.35,
          103.5,
          103.17,
          103.64,
          104.14,
          104.18,
          107.49,
          107.67,
          109.63,
          109.70,
          110.7,
          112.54,
        ]
  
  },
  ]
  }